import { useSearchParams } from 'react-router-dom';

export const useSetQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams);

  return (key: string, value: string) => setSearchParams({ ...params, [key]: value });
};
